import React, { useReducer, useContext, createContext } from "react";

const initialState = {
  alerts: [],
};

export const ALERT_ACTIONS = {
  ADD: "Add",
  REMOVE: "Remove",
  SET_DURATION: "Set_Duration",
};

export const ALERT_STATUSES = {
  SUCCESS: "Success",
  INFO: "Info",
  ERROR: "Error",
};

const reducer = (state, action) => {
  const tempAlerts = [...state.alerts];
  const alert = tempAlerts[0];

  switch (action.type) {
    case ALERT_ACTIONS.ADD:
      return {
        alerts: [
          ...state.alerts,
          {
            status: action.status,
            message: action.message,
            duration: action.duration || 5000,
          },
        ],
      };

    case ALERT_ACTIONS.REMOVE:
      tempAlerts.shift();

      return {
        alerts: [...tempAlerts],
      };

    case ALERT_ACTIONS.SET_DURATION:
      tempAlerts.splice(0, 1, {
        ...alert,
        duration: action?.payload,
      });

      return {
        alerts: [...tempAlerts],
      };

    default:
      return state;
  }
};

const AlertContext = createContext(initialState);

export default function AlertProvider({ children }) {
  return (
    <AlertContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </AlertContext.Provider>
  );
}

export const useAlert = () => useContext(AlertContext);
